import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
import moment from "moment";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      let date = new Date();
      commit("setIsThinking", true);
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }
      console.log("What is uncoming question: ", transcript);
      // Request to QNA
      let data;
      if (getters.getCurrentLanguage === "en") {
        data = JSON.stringify({
          question: transcript,
          lang: "english",
          client: "lasalle",
        });
      } else {
        data = JSON.stringify({
          question: transcript,
          lang: "spanish",
          client: "lasalle",
        });
      }
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      commit("setIsThinking", true);
      commit("setTextBubbleText", i18n.t("isThinking"));
      axios
        .request(config)
        .then((response) => {
          console.log("Response from AI: ", response.data);
          dispatch("addSessionDatatoStrapi", {
            applicationId: getters.getApplicationId,
            applicationSessionId: getters.getApplicationSessionId,
            actionType: "Speech",
            sessionPayload: {
              module: "QnA",
              action: transcript,
              response: response.data.answer.response,
            },
            timeStamp: date.toISOString(),
          });
          dispatch("generateAnswer", response.data);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error);
        });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      if (getters.getIsThinking) {
        router.push("/");
        commit("setQnaStatus", false);
        const metadata = result.answer.intent.toString();
        const ansObj = result.answer;
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (metadata) {
          case "1":
            var menuName = ansObj.metadata.path;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarSpeak", ansObj.response);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.answer);
            }
            break;

          case "4":
            dispatch("avatarSpeak", ansObj.response);
            break;
          //Search by Linkid
          case "2":
            commit("setQnaKeyword", "");
            router.addRoute({
              path: "/faqs",
              component: () => import("@/views/faqs"),
            });
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            var page = i18n
              .t("homepages")
              .filter((page) => page.pageType[0].pathName === "faqs");
            commit("setPageHeader", page[0].pageType[0].pageHeader);
            dispatch("avatarSpeak", ansObj.response);
            var linkId = ansObj.metadata.linkid;
            commit("setQnaKeyword", linkId);

            break;
          case "7":
            commit("setIsThinking", false);
            commit(
              "setTextBubbleText",
              "Please face towards the camera, tap on the microphone button, and ask a court-related question.",
            );
            window.open(ansObj.metadata.url, "_blank");

            break;
          case "8":
            // show pop up
            dispatch("avatarSpeak", ansObj.response);
            dispatch("openJuryOptionsViewer", {
              dialogHeader: i18n.t("selectTrafficeOptionMsg"),
              dialogData: ["Cash Payment", "Pay Online"],
            });
            break;
          case "0":
            var prompts = i18n.t("whatcanyoudo").split(",");
            var followUp = [];
            dispatch("avatarSpeak", ansObj.response);
            prompts.forEach((item) => followUp.push(item));
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followUp,
            });
            break;
          default:
            dispatch("avatarSpeak", i18n.t("kbError"));
            break;
        }
      }
    },
  },
};
